import styled from "styled-components";

export const SignInBlock = styled.div`
  width: 380px;
  display: flex;
  flex-direction: column;
`;
